import { SIZE_50 } from '@/lib/gridElements/size';

import { MediaViewerKpiLoader } from '@/components/base/Kpi/KpiLoader';

import { retweetsConfig } from '../retweets';

export const mediaViewerRetweetsSimpleConfig = {
    ...retweetsConfig,
    tooltip: null,
    size: SIZE_50,
    loader: MediaViewerKpiLoader
};
